/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Split_Multiview_DescriptionInputs */



/**
* | output |
* | --- |
* | "Create a new subtitle event group for each track. The multiview group will not be modified." |
*
* @param {Split_Multiview_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const split_multiview_description = /** @type {((inputs?: Split_Multiview_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Split_Multiview_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créez un nouveau groupe d'événements de sous-titres pour chaque piste. Le groupe multivue ne sera pas modifié.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstellen Sie für jede Tonspur eine neue Untertitel-Ereignisgruppe. Die Multiview-Gruppe wird nicht verändert.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea un nuovo gruppo di eventi per i sottotitoli per ogni traccia. Il gruppo multiview non verrà modificato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создайте новую группу событий субтитров для каждой дорожки. Группа событий мультипросмотра изменяться не будет.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crea un nuevo grupo de eventos de subtítulos para cada pista. El grupo multivista no se modificará.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("为每个轨道创建一个新的字幕事件组。多视图组将不会被修改。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("各トラックごとに新しい字幕イベントグループを作成します。マルチビューグループは変更されません。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रत्येक ट्रैक के लिए एक नया सबटाइटल इवेंट ग्रुप बनाएं। मल्टीव्यू ग्रुप में कोई बदलाव नहीं किया जाएगा।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Crie um novo grupo de eventos de legenda para cada faixa. O grupo de visualização múltipla não será modificado.")
	return /** @type {LocalizedString} */ ("Create a new subtitle event group for each track. The multiview group will not be modified.")
});